export default () => {
  $(document).on('cartDidOpen', () => {
    console.log('Should resize');
    $(window).trigger('resize');
  });
};
